import { useDispatch, useSelector } from "react-redux";
import { downloadAnnualExcel } from "../thunks/downloadAnnualExcel";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useAnnualExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.annualTrade.downloadReportFetchState
  );

  const dispatch = useDispatch();
  const download = React.useCallback(() => dispatch(downloadAnnualExcel()), [
    dispatch,
  ]);

  return [download, fetchState] as [typeof download, typeof fetchState];
};
